import { http } from "./config";
import authHeader from "./auth-header";

const endpointRelatorioSeguro = (tipoRelatorio, xls = false) =>
  `/relatorio-seguro/${tipoRelatorio}${xls ? "-xls" : ""}`;

export default {
  consultarRelatorioSeguro(tipoRelatorio, params) {
    return http.get(endpointRelatorioSeguro(tipoRelatorio), {
      headers: authHeader(),
      params,
    });
  },

  downloadRelatorioSeguro(tipoRelatorio, params) {
    return http.get(endpointRelatorioSeguro(tipoRelatorio, true), {
      headers: authHeader(),
      params,
      responseType: "arraybuffer",
    });
  },

  listarPlanosSeguro(params) {
    return http.get("/relatorio-seguro/config/planos", {
      headers: authHeader(),
      params,
    });
  },

  salvarPlanoSeguro(payload) {
    return http.post("/relatorio-seguro/config/planos", payload, {
      headers: authHeader(),
    });
  },

  alterarStatusPlanoSeguro(id, ativo) {
    return http.patch("/relatorio-seguro/config/planos/status", null, {
      headers: authHeader(),
      params: { id, ativo },
    });
  },

  listarTiposContratoSeguro(empresa) {
    return http.get("/relatorio-seguro/config/tipos-contrato", {
      headers: authHeader(),
      params: { empresa },
    });
  },
};
